import React from "react";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEntitlements } from "../hooks/useEntitlement";
import { getDefaultRoute } from "../utils/EntitlementUtils";
import {
  selectCallerAccountId,
  selectIsCallerAccountsInvoked,
} from "../store/app-config/AppConfigSelectors";

export const DefaultRouteRedirect: React.FC = () => {
  const entitlements = useEntitlements();
  const accountId = useSelector(selectCallerAccountId);
  const isCallerAccountsInvoked = useSelector(selectIsCallerAccountsInvoked);

  const isLoading = !accountId || !isCallerAccountsInvoked;

  if (isLoading) {
    return null;
  }

  const defaultRoute = getDefaultRoute(entitlements);
  return <Redirect to={defaultRoute} />;
};
